/**
 * The returned Promise fails if cookies are not accepted and resolves if they are accepted.
 */
export const isPrivacyCookieAccepted = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        // support for new cookie layer
        if ((window as any)?.trumpf?.ux?.uiCookieConsent) {
            const hasConsentedOptional = (window as any).trumpf.ux.uiCookieConsent.client?.hasConsented(
                "optional"
            );
            if (hasConsentedOptional) {
                resolve();
            } else {
                reject();
            }
            return;
        }
        // support for old cookie layer
        if (typeof require === "function") {
            require(["minified/_privacy-cookie-controller.min"], (
                cookieController
            ) => {
                if (cookieController.isAcceptedOptionalCookie("cookies")) {
                    resolve();
                } else {
                    reject();
                }
            });
            return;
        }
        reject();
    });
};
